<!-- 用户管理新增 -->
<template>
  <el-dialog
    :visible.sync="visible"
    :title="!dataForm.id ? '新增用户' : '编辑用户'"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <div>
      <el-form
        :model="dataForm"
        :rules="dataRule"
        ref="dataForm"
        @keyup.enter.native="dataFormSubmitHandle()"
        label-width="120px"
      >
        <!-- <el-form-item prop="username" :label="$t('user.username')">
          <el-input
            v-model="dataForm.username"
            :placeholder="$t('user.username')"
          ></el-input>
        </el-form-item> -->
        <el-form-item prop="realName" label="用户姓名">
          <el-input
            v-model="dataForm.realName"
            placeholder="请输入用户姓名"
          ></el-input>
        </el-form-item>
        <el-form-item prop="mobile" label="联系方式">
          <el-input
            v-model="dataForm.mobile"
            placeholder="请输入联系方式"
          ></el-input>
        </el-form-item>
        <el-form-item prop="type" label="用户类型">
          <!-- 1:民宿老板2:出租老板3:后台管理员 -->
          <el-select size="small" v-model="dataForm.type" @change="selectType">
            <el-option label="民宿老板" value="1"></el-option>
            <el-option label="出租老板" value="2"></el-option>
            <!-- <el-option label="后台管理员" value="3"></el-option> -->
          </el-select>
        </el-form-item>
        <el-form-item prop="password" label="密码">
          <el-input
            type="password"
            v-model="dataForm.password"
            placeholder="请输入密码"
          ></el-input>
        </el-form-item>
        <el-form-item prop="confirmPassword" label="确认密码">
          <!-- :class="{ 'is-required': !dataForm.id }" -->
          <el-input
            v-model="dataForm.confirmPassword"
            type="password"
            placeholder="确认密码"
          ></el-input>
        </el-form-item>
        <el-form-item
          prop="headUrl"
          label="微信头像"
          v-if="dataForm.id && dataForm.headUrl"
        >
          <el-image :src="dataForm.headUrl"></el-image>
        </el-form-item>
        <el-form-item
          prop="nickName"
          label="微信昵称"
          v-if="dataForm.id && dataForm.nickName"
        >
          {{ dataForm.nickName }}
        </el-form-item>
        <!-- <el-form-item prop="businessLicense" label="营业执照">
          <el-upload
            v-model="dataForm.businessLicense"
            class="upload-demo"
            drag
            :limit="1"
            action
            accept=".jpg,.png,.PNG,.JPG"
            :before-upload="beforeUpload"
            :http-request="(e, type) => uploadFileVideo(e, '1')"
            :on-remove="handleRemove"
            :on-exceed="Exceed"
          >
            <img v-if="imageUrl" :src="imageUrl" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            <div class="el-upload__tip" slot="tip">
              只能上传jpg/png文件
            </div>
          </el-upload>
        </el-form-item> -->
        <el-form-item prop="homeStayNum" label="管理民宿数量">
          <el-input
            v-model="dataForm.homeStayNum"
            placeholder="请输入管理的民宿数量"
          ></el-input>
        </el-form-item>
        <el-form-item prop="status" label="状态" size="mini">
          <el-radio-group v-model="dataForm.status">
            <el-radio :label="0">冻结</el-radio>
            <el-radio :label="1">启用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-button @click="visible = false">cancel</el-button>
          <el-button type="primary" @click="dataFormSubmitHandle()"
            >save</el-button
          >
        </el-form-item>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
import debounce from "lodash/debounce";
import Cookies from "js-cookie";
import { isEmail, isMobile } from "@/utils/validate";
export default {
  data() {
    return {
      visible: false,
      roleList: [],
      geneIdList: [],
      roleIdListDefault: [],
      dataForm: {
        id: "",
        username: "",
        type: "",
        realName: "",
        mobile: "",
        homeStayNum: "",
        status: 1,
        password: "",
        confirmPassword: "",
        roleIdList: [],
        businessLicense: "",
      },
      imageUrl: [],
    };
  },
  computed: {
    dataRule() {
      var validatePassword = (rule, value, callback) => {
        if (!this.dataForm.id && !/\S/.test(value)) {
          return callback(new Error(this.$t("validate.required")));
        }
        callback();
      };
      var validateConfirmPassword = (rule, value, callback) => {
        if (!this.dataForm.id && !/\S/.test(value)) {
          return callback(new Error(this.$t("validate.required")));
        }
        if (this.dataForm.password !== value) {
          return callback(new Error(this.$t("user.validate.confirmPassword")));
        }
        callback();
      };
      var validateMobile = (rule, value, callback) => {
        if (value && !isMobile(value)) {
          return callback(
            new Error(
              this.$t("validate.format", { attr: this.$t("user.mobile") })
            )
          );
        }
        callback();
      };
      return {
        // username: [
        //   {
        //     required: true,
        //     message: this.$t("validate.required"),
        //     trigger: "blur",
        //   },
        // ],
        realName: [
          {
            required: true,
            message: "用户姓名",
            trigger: "blur",
          },
        ],
        mobile: [
          {
            required: true,
            message: "联系方式不能为空",
            trigger: "blur",
          },
          { validator: validateMobile, trigger: "blur" },
        ],
        homeStayNum: [
          {
            required: true,
            message: "管理的民宿数量不能为空",
            trigger: "blur",
          },
        ],
        password: [{ validator: validatePassword, trigger: "blur" }],
        confirmPassword: [
          { validator: validateConfirmPassword, trigger: "blur" },
        ],
        type: [
          {
            required: true,
            message: "用户类型不能为空",
            trigger: "blur",
          },
        ],
      };
    },
  },
  methods: {
    selectType(e) {
      console.log("e", e);
      if (e != 1) {
        this.dataRule["homeStayNum"][0].required = false;
      } else {
        this.dataRule["homeStayNum"][0].required = true;
      }
    },
    init() {
      this.visible = true;
      // this.dataForm.deptId = "";
      this.imageUrl = "";
      this.$nextTick(() => {
        this.$refs["dataForm"].resetFields();
        this.roleIdListDefault = [];
        Promise.all([this.getRoleList()]).then(() => {
          if (this.dataForm.id) {
            this.getInfo();
          }
        });
      });
    },
    // 获取角色列表
    getRoleList() {
      return this.$http
        .get("/sys/role/list")
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg);
          }
          this.roleList = res.data;
        })
        .catch(() => {});
    },
    // 获取信息
    getInfo() {
      this.$http
        .get(`/sys/user/${this.dataForm.id}`)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg);
          }
          this.dataForm = {
            ...this.dataForm,
            ...res.data,
            roleIdList: [],
          };
          // 角色配置, 区分是否为默认角色
          for (var i = 0; i < res.data.roleIdList.length; i++) {
            if (
              this.roleList.filter(
                (item) => item.id === res.data.roleIdList[i]
              )[0]
            ) {
              this.dataForm.roleIdList.push(res.data.roleIdList[i]);
              continue;
            }
            if (this.dataForm.type == 1) {
              this.dataRule["homeStayNum"].required = false;
            } else {
              this.dataRule["homeStayNum"].required = true;
            }
            this.roleIdListDefault.push(res.data.roleIdList[i]);
          }
        })
        .catch(() => {});
    },
    // 表单提交
    dataFormSubmitHandle: debounce(
      function() {
        this.$refs["dataForm"].validate((valid) => {
          if (!valid) {
            return false;
          }
          this.dataForm.username = this.dataForm.mobile;
          if (!this.dataForm.roleIdList) {
            this.dataForm.roleIdList = [this.roleList[0].id];
          }
          this.$http[!this.dataForm.id ? "post" : "put"]("/sys/user", {
            ...this.dataForm,
            roleIdList: [
              ...this.dataForm.roleIdList,
              ...this.roleIdListDefault,
            ],
          })
            .then(({ data: res }) => {
              if (res.code !== 0) {
                return this.$message.error(res.msg);
              }
              this.$message({
                message: this.$t("prompt.success"),
                type: "success",
                duration: 500,
                onClose: () => {
                  this.visible = false;
                  this.$emit("refreshDataList");
                },
              });
            })
            .catch(() => {});
        });
      },
      1000,
      { leading: true, trailing: false }
    ),
    //上传文件
    uploadFileVideo(e) {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let formData = new FormData();
      // var url = (this.url = `${
      //   window.SITE_CONFIG["apiUpURL"]
      // }/sys/oss/upload?token=${Cookies.get("token")}`);
      var url = (this.url = `/sys/oss/upload?token=${Cookies.get("token")}`);

      formData.append("file", e.file);
      this.$http
        .post(url, formData)
        .then((res) => {
          console.log("文件", res);
          loading.close();
          this.imageUrl = res.data.data;
          this.$message({
            message: this.$t("prompt.success"),
            type: "success",
            duration: 500,
          });
        })
        .catch((err) => {
          loading.close();
        });
    },
    //删除文件
    handleRemove(file, fileList) {
      this.fileList = fileList;
    },
    beforeUpload(file) {
      console.log("file", file);
      // let suffixList = "mp4";
      // let extend = file.name.substring(file.name.lastIndexOf(".") + 1);
      // if (suffixList.indexOf(extend) != -1) {
      //   return true;
      // } else {
      //   this.$message.warning(`请上传${suffixList}格式的文件！`);
      //   return false;
      // }
    },
    //文件超出
    Exceed() {
      this.$message.error("最多上传一个文件~");
    },
  },
};
</script>

<style lang="scss">
.mod-sys__user {
  .role-list {
    .el-select {
      width: 100%;
    }
  }
}
.avatar {
  width: 100%;
  height: 100%;
}
</style>
